import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ProvisionItemCta } from 'Src/feature/provision/ProvisionItemCTA';
import { TerminalOption } from 'Src/feature/provision/provisionService';
import { StatusAdornmentProps } from 'Src/feature/status/StatusAdornment';

interface TerminalListItemProps {
  terminal: TerminalOption;
  disabled?: boolean;
  selected?: boolean;
  onClick?: () => void;
}
const TerminalListItem: FC<TerminalListItemProps> = ({
  terminal,
  onClick,
  selected,
  disabled,
  ...rest
}) => {
  const { t } = useTranslation();

  const heartbeat = terminal.heartbeatData;
  const isOnline = typeof heartbeat?.lastHeartbeat === 'number' && heartbeat.lastHeartbeat >= Date.now() - 1000 * 60 * 5; // active w/i last 5 min
  let indicatorMessage = '';
  let statusColor: StatusAdornmentProps['color'] = 'unknown';
  if (terminal.isProvisioned) {
    if (isOnline) {
      statusColor = 'success';
      indicatorMessage = t('labels.online');
    } else {
      statusColor = 'error';
      indicatorMessage = t('labels.offline');
    }
  }

  return (
    <ProvisionItemCta
      {...rest}
      selected={selected}
      disabled={disabled}
      onClick={onClick}
      title={terminal.name}
      subTitle={terminal.role === 'POS' ? t('labels.pos') : t('labels.timeClock')}
      indicator={{
        message: indicatorMessage,
        color: statusColor,
      }}
    />
  );
};

export default TerminalListItem;
